import i18next from 'i18next';
import { printValue } from 'yup';

function getFieldName(path) {
    return i18next.exists(path) ? i18next.t(path) : 'Bu alan';
}

export default {
    mixed: {
        default: ({ path }) => `${getFieldName(path)} geçersiz`,
        required: ({ path }) => `${getFieldName(path)} zorunlu bir alandır`,
        defined: ({ path }) => `${getFieldName(path)} tanımlanmalıdır`,
        notNull: ({ path }) => `${getFieldName(path)} null olamaz`,
        oneOf: ({ path, values }) =>
            `${getFieldName(path)} şu değerlerden biri olmalıdır: ${i18next.t(values)}`,
        notOneOf: ({ path, values }) =>
            `${getFieldName(path)} şu değerlerden biri olmamalıdır: ${i18next.t(values)}`,
        notType: ({ path, type, value, originalValue }) => {
            const isCast = originalValue != null && originalValue !== value;
            let msg =
                `${getFieldName(path)} bir \`${i18next.t(type)}\` türü olmalıdır, ` +
                `ancak son değer: \`${printValue(value, true)}\`` +
                (isCast
                    ? ` (\`${printValue(originalValue, true)}\` değerinden dönüştürüldü).`
                    : '.');

            if (value === null) {
                msg +=
                    `\n Eğer "null" boş bir değer olarak düşünülüyorsa, şemayı` +
                    ' `.nullable()` olarak işaretlediğinizden emin olun';
            }

            return msg;
        },
    },
    string: {
        length: ({ path, length }) =>
            `${getFieldName(path)} tam olarak ${length} karakter olmalıdır`,
        min: ({ path, min }) => `${getFieldName(path)} en az ${min} karakter olmalıdır`,
        max: ({ path, max }) => `${getFieldName(path)} en fazla ${max} karakter olmalıdır`,
        matches: ({ path, regex }) => `${getFieldName(path)} şu düzenle eşleşmelidir: "${regex}"`,
        email: ({ path }) => `${getFieldName(path)} geçerli bir e-posta olmalıdır`,
        url: ({ path }) => `${getFieldName(path)} geçerli bir URL olmalıdır`,
        uuid: ({ path }) => `${getFieldName(path)} geçerli bir UUID olmalıdır`,
        trim: ({ path }) => `${getFieldName(path)} kırpılmış bir dize olmalıdır`,
        lowercase: ({ path }) => `${getFieldName(path)} küçük harfli bir dize olmalıdır`,
        uppercase: ({ path }) => `${getFieldName(path)} büyük harfli bir dize olmalıdır`,
    },
    number: {
        min: ({ path, min }) => `${getFieldName(path)} ${min} değerinden büyük veya eşit olmalıdır`,
        max: ({ path, max }) => `${getFieldName(path)} ${max} değerinden küçük veya eşit olmalıdır`,
        lessThan: ({ path, less }) => `${getFieldName(path)} ${less} değerinden küçük olmalıdır`,
        moreThan: ({ path, more }) => `${getFieldName(path)} ${more} değerinden büyük olmalıdır`,
        positive: ({ path }) => `${getFieldName(path)} pozitif bir sayı olmalıdır`,
        negative: ({ path }) => `${getFieldName(path)} negatif bir sayı olmalıdır`,
        integer: ({ path }) => `${getFieldName(path)} bir tam sayı olmalıdır`,
    },
    date: {
        min: ({ path, min }) => `${getFieldName(path)} alanı ${min} tarihinden sonra olmalıdır`,
        max: ({ path, max }) => `${getFieldName(path)} alanı ${max} tarihinden önce olmalıdır`,
    },
    object: {
        noUnknown: ({ path, unknown }) =>
            `${getFieldName(path)} alanında belirtilmemiş anahtarlar var: ${i18next.t(unknown)}`,
    },
    array: {
        min: ({ path, min }) => `${getFieldName(path)} alanında en az ${min} öğe olmalıdır`,
        max: ({ path, max }) => `${getFieldName(path)} alanında en fazla ${max} öğe olmalıdır`,
        length: ({ path, length }) => `${getFieldName(path)} ${length} öğe içermelidir`,
    },
    boolean: {
        isValue: ({ path, value }) => `${getFieldName(path)} alanı ${i18next.t(value)} olmalıdır`,
    },
};
